<template>
  <div class="collectList">
    <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loadings" infinite-scroll-distance="10" class="lists">
      <li @click="gotodetail(item.id)"  v-for="item in collectionList" class="collectItem">
        <div class="tongzhitime">
          <span class="tongzhimonth">{{item.dayMonth}}</span>
          <span class="tongzhiyear">{{item.year}}</span>
        </div>
        <div class="tongzhicont">
          <span class="tongzhiheader">{{item.headline}}</span>
          <span class="tongzhiIntroduce">{{item.description}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import { Indicator } from 'mint-ui';
  export default {
    name: "newslast",
    data(){
      return {
        collectionList:[],
        loadings:true,
        page:1,
        size:6
      }
    },
    mounted(){
      this.getCollections(true);
    },
    methods: {
      loadMore() {
        this.page ++;
        this.loadings = true;
        this.getCollections(true);

       /* setTimeout(() => {
          this.page ++;
          this.getCollections(true);
        }, 1000);*/
      },
      gotodetail(id) {
        this.$router.push({
          path: 'lastDetail',
          query: {id: id}
        });
      },
      getCollections(flag) {
        let that = this;
        let params={uniqueName:'tzgg',currentPage:this.page,size:this.size};
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        this.$http.get(api.getArticleListByUniqueType, {params:params}).then(response => {

          if(response.data.success==1){
            Indicator.close();
            if(flag){
              that.collectionList = that.collectionList.concat(response.data.data);
              //that.total = response.data.others.total;
              if(response.data.data.length == 0){
                this.loadings = true;
              }else{
                this.loadings = false;
              }
            }else{
              this.collectionList = response.data.data;
              this.loadings = false;
            }
          }else{
            console.log("接口异常");
          }
        }, response => {
          console.log("请求失败了");
        })
      },
    }
  }
</script>

<style scoped>
  .collectList{
    padding: 0rem .75rem 2.45rem;
  }
  .lists{
    margin: 0;
  }
  .collectItem{
    height:3.1rem;
    border-radius: 0.4rem;
    padding: .55rem .75rem;
    background-color: rgba(241, 241, 242, 1);
    margin-top: 0;
    margin-bottom: .5rem;
  }
.tongzhitime{
  width: 2.1rem;
  height: 2.15rem;
  line-height: 1.25rem;
  color: rgba(196, 77, 65, 1);
  text-align: left;
  display: inline-block;
  font-family: PingFang-SC-Bold;
  vertical-align: top;
  margin-top: .25rem;
}
  .tongzhimonth{
    font-size: .9rem;
    display: block;
    color: #C44D41;
  }
  .tongzhiyear{
    font-size: .6rem;
    display: block;
    color: #333333;
  }
  .tongzhicont{
   display: inline-block;
    width: 12.5rem;
    margin-left: .8rem;
  }
  .tongzhiheader{
    width: 12.5rem;
    height: 0.7rem;
    margin-top: .2rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
  .tongzhiIntroduce{
    width: 12.5rem;
    height: 1.85rem;
    line-height: 0.9rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.65rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */

    margin-top: .35rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/newslast.vue